import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { DesignationPostDataAPI } from '../../../../Redux/SidebarMasterSlice/DesignationSlice';
import { RegExOnlyText } from '../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../Helper/AstricSign';
import { RoleNameDataDDL } from '../../../../Components/CommonDDL/RoleNameDataDDL';
import { ProjectTypeDataDDL } from '../../../../Components/CommonDDL/ProjectTypeDataDDL';


export default function DesignationPopup(props) {

    const { item, EditIcon, Flag, handleIsPost, rowData, open, handleOnCloseClick } = props

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID } = userDetails.user
    const dispatch = useDispatch();

    // const [rowData, setRowData] = useState(Flag === 'Update' ? item : '')

    const [DesignationName, setDesignationName] = useState(Flag === 'Update' ? rowData.designationName : '')

    const [Role, setRole] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_RoleID : 0,
        Label: Flag === 'Update' ? rowData.role : "Select...",
    })

    const [Department, setDepartment] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_ProjectTypeID : 0,
        Label: Flag === 'Update' ? rowData.projectType : "Select...",
    })

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const [IsOpen, setIsOpen] = useState(false)

    // useEffect(() => {
    //     setDesignationName(Flag === 'Update' ? rowData.designationName : '')
    // }, [item, IsOpen])

    const handlePost = () => {
        const data = {
            M_DesignationID: Flag === 'Update' ? rowData.id : '0',
            DesignationName: DesignationName,
            M_RoleID: Role.ID ?? 0,
            M_ProjectTypeID: ProjectType?.ID,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(DesignationPostDataAPI({ data }))
    }

    const [IsValidText, setIsValidText] = useState(false)
    const handleCheckText = (e) => {
        setDesignationName(e.target.value)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    return (

        // <Popup
        //     onOpen={() => setIsOpen(!IsOpen)}
        //     contentStyle={{ top: '5%' }}
        //     trigger={
        //         EditIcon === 'Update' ?
        //             <i className="fa-solid fa-pen-to-square"
        //             title='Edit' style={{ cursor: 'pointer' }}
        //             >
        //             </i> :
        //             <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
        //                 style={{ color: "white", marginTop: '-2.5em' }}
        //             >
        //                 <text className="ml-2 poppins">Add</text>
        //             </i>
        //     }
        //     modal
        // >

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-xl" style={{ overflow: 'visible' }}>
                <div className="modal-content master_border" style={{ overflow: 'visible' }}>
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Designation</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">
                                <div className="col-md-6 col-lg-6">
                                    <ProjectTypeDataDDL
                                        ProjectType={ProjectType}
                                        setProjectType={setProjectType}
                                        Flag={Flag}
                                        rowData={rowData}
                                    />
                                </div>
                                {/* <div className="col-md-6 col-lg-6">
                                    <RoleNameDataDDL
                                        Role={Role}
                                        setRole={setRole}
                                        // rowData={item}
                                        rowData={rowData}
                                        Flag={Flag}
                                        M_ProjectTypeID={ProjectType?.ID}
                                    />
                                </div> */}

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Designation Name <AstricSign /> </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="DesignationName"
                                            // value={DesignationName}                                          
                                            value={DesignationName}
                                            // onChange={(e) => handleCheckText(e)}
                                            onChange={(e) => setDesignationName(e.target.value)}
                                        />
                                        {/* {
                                            IsValidText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                        } */}
                                    </div>
                                </div>

                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            DesignationName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}